import { Pipe, PipeTransform } from '@angular/core';

import { ProgramMembershipRole } from '@libs/src/models/program-membership.model';
import { Program } from '@libs/src/models/program.model';
import { getCustomRoleFromUserProgramRole } from '@libs/src/program-memberships/program-membership.helper';

@Pipe({
  name: 'getCustomRoleFromProgramRoles',
})
export class GetCustomRoleFromProgramRolesPipe implements PipeTransform {
  transform(
    programRoles: ProgramMembershipRole[],
    userProgramRole: string,
    config: Program['program_config'],
  ): ProgramMembershipRole {
    if (!userProgramRole) {
      return { label: '', shortLabel: '', value: '' };
    }
    const customRole = getCustomRoleFromUserProgramRole(
      userProgramRole,
      config?.primary_name,
      config?.secondary_name,
    );
    return programRoles.find((role) => customRole === role.value);
  }
}
